export const defaultColors = {
  background: "white",
  originInput: "white",
  originInputText: "#999",
  destinationInput: "white",
  destinationInputText: "#999",
  departureTimeInput: "white",
  searchTripButtonBg: "#008761",
  searchTripButtonText: "white",
  searchTripButtonBorder: "#008761",
  searchByLineTitle: "gray.600",
  searchByLineSubtext: "gray.600",
  searchByLineButtonBg: "white",
  searchByLineButtonText: "#008761",
  searchByLineButtonBorder: "#008761",
}
